import { Outlet, Navigate } from 'react-router-dom';
import useAuthStore from '../stores/authStore';

const PrivateRoutes = () => {
    const { user } = useAuthStore();
    return (
        <>
            {user && user.emailVerified ? <Outlet /> : <Navigate to="/login" />}
        </>
    );
};

export default PrivateRoutes;